import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ShipmentItemsActions } from '../StoreAdapter'
import { ShipmentItemSchema } from '../../../Schema/ShipmentItemSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ShipmentItemsAPI } from '../../../Services/API/ShipmentItemsAPI'

export const useDeleteShipmentItem = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const deleteShipmentItem = useCallback(
    async (schemaId: string): Promise<ShipmentItemSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ShipmentItemsAPI)
        .deleteEntity(schemaId)
        .then((schema) => {
          dispatch(ShipmentItemsActions.removeOne(schemaId))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err?.response?.data?.errorMessage)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    deleteShipmentItem,
  }
}
